import { getBlogList, getBlogDetail, getBlogCategories } from '@/api/blog'
import { REQUEST_SUCCESS_CODE } from '@/config/constant'

export default {
    namespaced: true,
    state: {
        categories: [],
        listCache: {},
        detailCache: {}
    },
    getters: {
        categories: (state: any) => state.categories,
        getListCache: (state: any) => (key: string) => state.listCache[key] || null,
        getDetailCache: (state: any) => (slug: string) => state.detailCache[slug] || null
    },
    mutations: {
        SET_CATEGORIES(state: any, data: any) {
            state.categories = data
        },
        SET_LIST_CACHE(state: any, { key, data }: any) {
            state.listCache[key] = data
        },
        SET_DETAIL_CACHE(state: any, { slug, data }: any) {
            state.detailCache[slug] = data
        }
    },
    actions: {
        async fetchCategories({ commit, state }: any) {
            if (state.categories.length > 0) return state.categories
            
            try {
                const res = await getBlogCategories()
                if (res.code === REQUEST_SUCCESS_CODE) {
                    commit('SET_CATEGORIES', res.data || [])
                    return res.data || []
                }
            } catch (e) {
                // silent
            }
            return []
        },
        async fetchList({ commit, state }: any, { category, current, size }: any) {
            const cacheKey = `${category || 'all'}-${current}-${size}`
            if (state.listCache[cacheKey]) return state.listCache[cacheKey]

            try {
                const res = await getBlogList({ category, current, size })
                if (res.code === REQUEST_SUCCESS_CODE) {
                    commit('SET_LIST_CACHE', { key: cacheKey, data: res.data })
                    return res.data
                }
            } catch (e) {
                // silent
            }
            return null
        },
        async fetchDetail({ commit, state }: any, slug: string) {
            if (state.detailCache[slug]) return state.detailCache[slug]

            try {
                const res = await getBlogDetail(slug)
                if (res.code === REQUEST_SUCCESS_CODE && res.data) {
                    commit('SET_DETAIL_CACHE', { slug, data: res.data })
                    return res.data
                }
            } catch (e) {
                // silent
            }
            return null
        }
    }
}
